import { createTheme } from '@mui/material';

const palette = {
  primary: {
    light: '#FFA922',
    main: '#FF8900',
    // dark: string,
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#5491F9',
  },
  text: {
    primary: '#121212',
    secondary: '#999999',
  },
};

export const theme = createTheme({
  palette,
  typography: {
    fontFamily: ['Montserrat'].join(','),
    fontWeightRegular: 500,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 50,
          textTransform: 'unset',
          fontWeight: 600,
          paddingTop: 5,
          paddingBottom: 5,
          boxShadow: 'none',
        },
        contained: {
          '&:hover': {
            backgroundColor: palette.primary.light,
            boxShadow: 'none',
          },
        },
        sizeLarge: {
          height: 56,
          fontSize: 19,
          fontWeight: 600,
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(250, 250, 250, .8)',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontWeight: 500,
          color: 'rgba(0, 0, 0, 0.4)',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          '&:hover': {
            backgroundColor: `${palette.primary.main}20`,
            color: palette.primary.main,
          },
          '&.Mui-selected': {
            backgroundColor: `${palette.primary.main}10`,
            color: palette.primary.main,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0px 0px 4px rgb(0 0 0 / 12%)',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          minWidth: 0,
          padding: 8,
        },
      },
    },
  },
});

export const footerZIndex = theme.zIndex.appBar - 10;
